import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {API_ROOT} from '../../utils';
import Avatar from '../../components/avatar';
import Loader from '../../components/sprite/components/loader';
import MyProfileView from './components/my-profile-view';
import MyProfileEdit from './components/my-profile-edit';
import {
	putProfile,
	isLoadingProfileChange as setIsLoadingProfileChange,
	isEditModeProfile as setIsEditModeProfile,
	getProfile, putAvatarProfile, profileAvatarToUpload as setProfileAvatarToUpload
} from '../../../actions/profileActions';
import DirectoryWriteErrorPopup from '../../components/popup/components/directory-write-error-popup';
import {
	directoryWriteErrorPopup as setDirectoryWriteErrorPopup, isUpgradeToBusinessPopup,
} from '../../../actions/popupActions';
import MyProfileUpdatePropagation from './components/my-profile-update-propagation';
import './index.css';

function MyProfile () {

	const { t } = useTranslation();

	const profile = useSelector(state => state.profileReducer.getProfile);
	const directoryWriteErrorPopup = useSelector(state => state.popupReducer.directoryWriteErrorPopup);
	const isEditModeProfile = useSelector(state => state.profileReducer.isEditModeProfile);
	const isLoadingProfileChange = useSelector(state => state.profileReducer.isLoadingProfileChange);
	const isProfileUpdatePropagationPopup = useSelector(state => state.popupReducer.isProfileUpdatePropagationPopup);
	const profileAvatarToUpload = useSelector(state => state.profileReducer.profileAvatarToUpload);
	const hasTheBusinessPermission  = useSelector(state => state.permissionReducer.hasTheBusinessPermission);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getProfile(true))
	}, [dispatch]);

	const handleEdit = () => {

		if(!hasTheBusinessPermission){
			dispatch(isUpgradeToBusinessPopup(true));
			return;
		}

		if(profile.directoryWriteGranted === false){
			if(profile.isAdmin){
				window.location.href = API_ROOT + '/account/access-directoryWrite';
			} else {
				dispatch(setDirectoryWriteErrorPopup(true));
			}

			return;
		}

		dispatch(setIsEditModeProfile(true));
		dispatch(getProfile(true))
	};

	const handleCancel = () => {
		dispatch(setIsEditModeProfile(false));
		dispatch(setProfileAvatarToUpload(""));
	};

	const handleSave = (e) => {

		e.preventDefault();

		dispatch(setIsLoadingProfileChange(true));

		let phoneValues = [];

		document.querySelectorAll('.my-profile-phone').forEach(item => {
			phoneValues = phoneValues.concat({
				"label" : item.children[1].children[0].value,
				"number" : item.children[0].children[0].value
			});
		});

		let postalAddressValues = [];

		document.querySelectorAll('.my-profile-postal-address').forEach(item => {
			postalAddressValues = postalAddressValues.concat({
				"label" : item.children[1].children[0].value,
				"formattedAddress" : item.children[0].children[0].value
			})
		});

		dispatch(putProfile({
			"company": document.getElementById('myProfileCompany').value,
			"job": document.getElementById('myProfileJob').value,
			"department" : document.getElementById('myProfileDepartment').value,
			"phoneNumbers": phoneValues,
			"postalAddress": postalAddressValues,
			"building": document.getElementById('myProfileBuilding').value,
			"notes": document.getElementById('myProfileNotes').value,
		}));

		if(profileAvatarToUpload){
			dispatch(putAvatarProfile(profileAvatarToUpload));
		}

	};

	const browseHandler = (e) => {

		let file = e.target.files[0];
		let reader = new FileReader();

		reader.addEventListener('load', () => {
			dispatch(setProfileAvatarToUpload(reader.result.split(',')[1]));
		});

		if(file){
			reader.readAsDataURL(file);
		}

	};

	const clickHandler = (e) => {
		e.currentTarget.previousSibling.click();
	};

	if(profile){
		return (
			<div className="my-profile container p-3">
				{
					isProfileUpdatePropagationPopup
					?
						<MyProfileUpdatePropagation />
					:
						<>
							<h1>{t("profileHeading")}</h1>
							<div className="row overflow-auto">
								<div className="col-2 text-center">
									<Avatar
										className="mx-auto mb-3"
										size={96}
										src={
											profileAvatarToUpload === ""
											?
												profile.pictureUrl
											:
												'data:image/png;base64,' + profileAvatarToUpload
										}
										editableAvatar={isEditModeProfile}
										browseHandler={browseHandler}
										clickHandler={clickHandler}
									/>
								</div>
								{directoryWriteErrorPopup && <DirectoryWriteErrorPopup plan={profile.domain?.plan} />}
								{
									isEditModeProfile
										?
										<MyProfileEdit data={profile} handleCancel={handleCancel} handleSave={handleSave} isLoadingProfileChange={isLoadingProfileChange}/>
										:
										<MyProfileView data={profile} handleEdit={handleEdit} />
								}
							</div>
						</>
				}
			</div>
		)
	} else {
		return <Loader/>
	}

}

export default MyProfile;
